import { Breadcrumb } from 'antd';
import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  max-width: 840px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  align-self: center;
  height: 100%;
  & > :first-child {
    margin-bottom: 0 !important;
  }
`;

export const TitleWrapper = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.5px;
  }
`;

export const DescriptionWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  .ant-breadcrumb-link {
    cursor: pointer;
  }
`;
